/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum WoundsDressingsListAliases {
  BUTTON_ADD_WOUNDS_DRESSINGS = 'button-add-wounds-dressings',
  CARD_CONTAINER_BODY = 'card-container-body',
  CARD_CONTAINER_OSWALD = 'card-container-oswald',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK_WOUNDS_DRESSINGS = 'deck-wounds-dressings',
  FETCH_WOUNDS_DRESSINGS = 'fetch-wounds-dressings',
  GLOBAL_ACTIONS_WOUNDS_DRESSINGS_LIST = 'global-actions-wounds-dressings-list',
  ICON_MAPPER = 'icon-mapper',
  INFO_CARD_CONTAINER_ZONE = 'info-card-container-zone',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_WOUNDS_DRESSINGS_LIST = 'layout-wounds-dressings-list',
  LOCATION_FIELD = 'location-field',
  LOCATION_TEXT = 'location-text',
  MAIN_CARD_CONTAINER_ZONE = 'main-card-container-zone',
  MAIN_LEGENDS = 'main-legends',
  MAPPER_WOUNDS = 'mapper-wounds',
  PANEL_ACTIONS_WOUNDS_DRESSINGS = 'panel-actions-wounds-dressings',
  PROFESSIONAL_FIELD = 'professional-field',
  PROFESSIONAL_TEXT = 'professional-text',
  SCORE_FIELD = 'score-field',
  SCORE_TEXT = 'score-text',
  SECTOR_FIELD = 'sector-field',
  SECTOR_TEXT = 'sector-text',
  STATUS_CARD_CONTAINER_ZONE = 'status-card-container-zone',
  STATUS_ICON_SWITCHER = 'status-icon-switcher',
}
export { WoundsDressingsListAliases };
